<dx-select-box #selectBox
    [dataSource]="sftpVersions"
    [value]="selectedItem"
    displayExpr="name"
    valueExpr="id"
    [showClearButton]="true"
    [disabled]="loading"
    (selectedItemChange)="onSelectedItemChange($event)">
</dx-select-box>
